/**
 * Created by andrey on 06.08.2026
 *
 * https://docs.robokassa.ru/ru/pay-interface
 */

const RoboKassaPayments = function () {
    RestPayments.call(this, connector.ROBOKASSA);
};

RoboKassaPayments.prototype = Object.create(RestPayments.prototype);
RoboKassaPayments.prototype.constructor = RoboKassaPayments;

RoboKassaPayments.prototype.getDefaultCurrency = function () {
    return "RUB";
};

RoboKassaPayments.prototype.getPriceToBePaid = function (product) {
    return product.price;
};

RoboKassaPayments.prototype.purchase = function (product, callback, options) {
    if (product.type === "subscription") {
        callback(ERRORS.PURCHASE.UNKNOWN);
        return;
    }

    const purchase = this.createPurchase(undefined, product);
    const finishUrl = `${connector.config.payApiURL}/robokassapayments/finish/${encodeURIComponent(connector.platform.getUserID())}`;

    const data = { purchase, email: options.email, finishUrl };

    const savedCard = connector.dataLoader.load(SimpleDataLoader.TYPES.ROBOKASSA);
    if (savedCard && savedCard.opKey && options.savedCard !== false) {
        data.opKey = savedCard.opKey;
    }

    console.log("RoboKassaPayments.create", data);

    ConnectorRestClient.post("/robokassapayments/create", data, (response) => {
        console.log("RoboKassaPayments.create response", response.error || response.payment || response);

        if (response.error || !response.payment) {
            console.log(response.error || "empty payment");

            this.bus.trigger("stream:error", `RoboKassaPayments.purchase productId:${product.productId} ${JSON.stringify(response.error || "empty payment")}`);

            callback(ERRORS.PURCHASE.UNKNOWN);
            return;
        }

        const payment = response.payment;

        purchase.paymentId = payment.paymentId;

        const paymentUrl = payment.paymentUrl;
        const fallbackUrl = payment.fallbackUrl;

        console.log("RoboKassaPayments.create Success:", payment);

        if (payment.status === "succeeded") {
            callback(connector.CODE_SUCCEED, purchase);
        } else if (payment.status === "canceled") {
            callback(ERRORS.PURCHASE.CANCEL);
        } else if (payment.status === "pending" && purchase.paymentId && paymentUrl) {
            this.openPaymentFrame(purchase, paymentUrl, callback, fallbackUrl);
        } else {
            callback(ERRORS.PURCHASE.UNKNOWN);
        }
    }, (error) => {
        console.log("RoboKassaPayments.create Error:", error);

        callback(connector.CODE_FAILED);
    });
};

// load the payment page via the official iframe endpoint - the page gets appType=IFrame
// and sends external redirects (YandexPay, bank apps) to the parent via postMessage
// instead of navigating in place, where pay.yandex.ru is blocked by frame-ancestors CSP
RoboKassaPayments.prototype.postPaymentForm = function (frame, paymentUrl) {
    const form = document.createElement("form");
    form.action = RoboKassaPayments.IFRAME_URL;
    form.method = "POST";
    form.target = frame.name;
    form.style.display = "none";

    const params = new URL(paymentUrl).searchParams;
    params.set("Settings", JSON.stringify({ Mode: "modal" }));

    params.forEach((value, name) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    form.parentNode.removeChild(form);
};

RoboKassaPayments.prototype.openPaymentFrame = function (purchase, paymentUrl, callback, fallbackUrl) {
    const onPaymentClosedListener = this.onPaymentClosedListener = () => {
        console.log(`RoboKassaPayments.onPaymentClosedListener - ${this.getPurchaseState()}`);
        if (this.getPurchaseState() === PaymentsManager.STATE_PURCHASE) {
            this.startStatusPinger(purchase, callback);
        }
    };

    this.setNotifyActiveListener(() => this.onPaymentClosed());

    const frame = document.createElement("iframe");
    frame.style.position = "fixed";
    frame.style.left = "0";
    frame.style.top = "0";
    frame.style.height = "100%";
    frame.style.width = "100%";
    frame.style.zIndex = "1000000000";
    frame.style.border = "none";
    frame.style.background = "white";
    frame.id = "RoboKassaFrame";
    frame.name = "RoboKassaFrame";
    frame.allow = "payment";
    document.body.appendChild(frame);

    this.postPaymentForm(frame, paymentUrl);

    // fallback to the general payment page when the saved card page glitches
    let fallbackButton;
    if (fallbackUrl) {
        fallbackButton = document.createElement("div");
        fallbackButton.textContent = "Оплатить другим способом";
        fallbackButton.style.position = "fixed";
        fallbackButton.style.top = "12px";
        fallbackButton.style.left = "12px";
        fallbackButton.style.zIndex = "1000000001";
        fallbackButton.style.fontSize = "16px";
        fallbackButton.style.lineHeight = "28px";
        fallbackButton.style.color = "#ffffff";
        fallbackButton.style.textShadow = "0 1px 2px rgba(0, 0, 0, 0.4)";
        fallbackButton.style.cursor = "pointer";
        fallbackButton.style.textDecoration = "underline";
        fallbackButton.id = "RoboKassaFallback";
        document.body.appendChild(fallbackButton);

        fallbackButton.onclick = () => {
            console.log("RoboKassaPayments fallback");

            // pointerdown on the button has already fired notifyActive and started the pinger
            this.stopStatusPinger();
            this.onPaymentClosedListener = onPaymentClosedListener;
            this.setNotifyActiveListener(() => this.onPaymentClosed());

            this.postPaymentForm(frame, fallbackUrl);
            fallbackButton.parentNode.removeChild(fallbackButton);

            connector.dataLoader.remove(SimpleDataLoader.TYPES.ROBOKASSA);
        };
    }

    const messageHandler = (event) => {
        const action = event.data && event.data.action;

        console.log("RoboKassaPayments messageHandler - event", event);

        // "close" comes from our finish_callback.html on the payserver origin
        if (action === "close" || action === "closeRobokassaFrame") {
            this.closePaymentFrame();
            this.onPaymentClosed();
        }
    };

    this.closePaymentFrame = () => {
        window.removeEventListener("message", messageHandler);
        if (frame.parentNode) {
            frame.parentNode.removeChild(frame);
        }
        if (fallbackButton && fallbackButton.parentNode) {
            fallbackButton.parentNode.removeChild(fallbackButton);
        }
    };

    window.addEventListener("message", messageHandler);
};

RoboKassaPayments.prototype.onPaymentClosed = function () {
    if (this.onPaymentClosedListener) {
        this.onPaymentClosedListener();
        delete this.onPaymentClosedListener;
    }
};

RoboKassaPayments.prototype.stopStatusPinger = function () {
    if (this.statusPinger) {
        this.statusPinger.stop();
        delete this.statusPinger;
    }
};

RoboKassaPayments.prototype.startStatusPinger = function (purchase, callback) {
    this.stopStatusPinger();

    const waitPurchaseStateEndTime = Date.now() + RoboKassaPayments.WAIT_PURCHASE_STATE_TIMEOUT;

    this.statusPinger = new Pinger({
        action: (callback) => {
            console.log(`RoboKassaPayments.statusCheck: ${purchase.paymentId}`);
            const path = `/robokassapayments/get/${purchase.paymentId}`;

            ConnectorRestClient.get(path, {}, (response) => {
                if (response.error || !response.payment) {
                    console.log(response.error || "no payment");
                    callback(ERRORS.PURCHASE.UNKNOWN);
                    return;
                }

                const payment = response.payment;

                console.log("RoboKassaPayments.statusCheck success:", payment);

                if (payment.opKey && payment.account) {
                    connector.dataLoader.save(SimpleDataLoader.TYPES.ROBOKASSA, {
                        opKey: payment.opKey,
                        account: payment.account
                    });
                }

                if (payment.status === "succeeded") {
                    callback(connector.CODE_SUCCEED);
                } else if (payment.status === "canceled" || payment.purchaseState === "cancel") {
                    callback(connector.CODE_CANCELLED);
                } else if (Date.now() > waitPurchaseStateEndTime && !["finished", "success"].includes(payment.purchaseState)) {
                    // frame closed and no finish redirect arrived - user left without paying
                    console.log("RoboKassaPayments.statusCheck wait purchaseState timeout");
                    callback(connector.CODE_CANCELLED);
                } else {
                    callback(ERRORS.PURCHASE.UNKNOWN);
                }
            });
        },

        timeout: RoboKassaPayments.WAIT_SUCCEEDED_TIMEOUT,

        callback: (code) => {
            if (code === connector.CODE_SUCCEED) {
                callback(code, purchase);
            } else if (code === connector.CODE_CANCELLED) {
                callback(ERRORS.PURCHASE.CANCEL);
            } else {
                callback(ERRORS.PURCHASE.TIMEOUT);
            }
        }
    });
    this.statusPinger.start();
};

RoboKassaPayments.prototype.stopPurchaseActions = function () {
    RestPayments.prototype.stopPurchaseActions.call(this);

    this.stopStatusPinger();

    if (this.closePaymentFrame) {
        this.closePaymentFrame();
    }

    delete this.onPaymentClosedListener;
};

RoboKassaPayments.isAppropriate = function () {
    const config = connector.config.robokassa;

    return Boolean(config && config.merchantLogin)
        && (connector.platform.oneOf(connector.LABSYSTECH)
            || connector._countryManager.country === "RU" && connector.platform.oneOf(connector.CLEVERAPPS));
};

RoboKassaPayments.IFRAME_URL = "https://auth.robokassa.ru/merchant/v1/iframe";

RoboKassaPayments.WAIT_PURCHASE_STATE_TIMEOUT = connector.utils.parseInterval("3 seconds");
RoboKassaPayments.WAIT_SUCCEEDED_TIMEOUT = connector.utils.parseInterval("60 seconds");
